import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../../static/user/img/logo.svg";
import "./style.css";
import { connect } from "react-redux";
import { getFooterData, getDashboardData } from "../../../redux/action/common-action";
import { parseHtml } from "../../../utils/util";
import Subcriber from "../common/Subscriber";
import { UserRoutes } from "../../../routes";

const Footer = (props) => {
  const { footerData, getFooterData, dashboardData, getDashboardData } = props;
  const [menus, setMenus] = useState([]);
  const [bottomSection, setBottomSection] = useState({});
  const [staticData, setStaticData] = useState({});
  const location = useLocation();
  useEffect(() => {
    getFooterData();
    getDashboardData();
  }, []);
  useEffect(() => {
    if (dashboardData && dashboardData.newsLetterSection) {
      let data = setStaticData({ ...dashboardData });
    }
  }, [dashboardData]);
  useEffect(() => {
    setMenus(footerData?.menuSection || []);
    setBottomSection(footerData?.bottomSection || {});
  }, [footerData]);
  // console.log(location.pathname);
  // console.log("newsletterData", props);
  return (
    <>
      <footer id="pageFooter" className={location.pathname === UserRoutes.MY_ACCOUNT ? "d-none bg-footer position-relative text-center text-md-left wow fadeIn" : "bg-footer position-relative text-center text-md-left wow fadeIn"}>
        <div className="container">
          <Subcriber newsSection={staticData?.newsLetterSection} />
          {/* <div className="newsLetter text-center">
					<p className="big">Subscribe to Weekly<br /> 
						thoughts by Dr. Subhash Chandra.</p>
					<p className="small">Join our subscribers list to get weekly videos and thoughts from <br/>
						Dr. Subhash Chandra on diffrent topics, suggestions and solutions.</p>	
				</div>
				<div className="newsletterInput text-center">
					<div className="newsletterArea">
					<input type="text" className="newsletter" placeholder="Enter your Email ID" />
					<button className="newsBtn" value="Get Started">Get Started</button>
					</div>
				</div> */}
          <div className="f_social text-center">
            <label>{parseHtml(staticData?.topSection?.connectWithUsFooter)}</label>
            <div className="social-links">
              <ul className="text-lg-end px-0 mb-0">
                <li>
                  <a href="https://www.facebook.com/SubhashChandraFoundation" target="_blank" rel="noreferrer">
                    <i className="bi bi-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/Subhashchandra" target="_blank" rel="noreferrer">
                    <i className="bi bi-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/subhashchandrafoundation" target="_blank" rel="noreferrer">
                    <i className="bi bi-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/channel/UCXQbpATiZKmDnNc-XmN5PjA" target="_blank" rel="noreferrer">
                    <i className="bi bi-youtube"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <nav className="ftNav">
            <ul className="list-unstyled d-flex justify-content-center justify-content-md-start flex-wrap font-weight-normal text-uppercase mb-0">
              {menus.map((menu, fIndex) =>
                menu?.cta?.path === "grant" || menu?.cta?.path === "organic_farming" ? null : (
                  <li className="nav-item" key={fIndex}>
                    <Link className="nav-link" to={`/${menu?.cta?.path == "Counselling" ? "counseling" : menu?.cta?.path?.toLowerCase().replace(" ", "_")}`}>
                      {menu.title}
                    </Link>
                  </li>
                )
              )}
              {bottomSection?.subMenu?.map((menu, index) => (
                <li key={index} className="nav-item">
                  <Link to={`/${parseHtml(menu?.cta?.path.toLowerCase().replace(" ", "_"))}`}>
                    {/* {index !== 0 ? (
                        <span className="pe-2">
                          <i className="bi bi-circle-fill"></i>
                        </span>
                      ) : (
                        ""
                      )} */}
                    {parseHtml(menu.title)}
                  </Link>
                </li>
              ))}
            </ul>
            {/* <ul className="copyright-footer text-lg-end text-center px-0">
                {bottomSection?.subMenu?.map((menu, index) => (
                  <li key={index}>
                    <Link to={`/${parseHtml(menu?.cta?.path.toLowerCase().replace(" ", "_"))}`}>
                      {index !== 0 ? (
                        <span className="pe-2">
                          <i className="bi bi-circle-fill"></i>
                        </span>
                      ) : (
                        ""
                      )}
                      {parseHtml(menu.title)}
                    </Link>
                  </li>
                ))}
              </ul> */}
          </nav>
        </div>
        <div className="container">
          <div className="textCopyright">
            <p>
              <strong className="fwMedium">
                <span>{bottomSection?.title}</span>
              </strong>
            </p>
          </div>
        </div>
        {/* <a href="#pageWrapper" className="btnTop smooth fas fa-arrow-up d-none d-md-flex align-items-center justify-content-center bg-warning position-absolute"><span className="sr-only">back to top</span></a> */}
        <div id="loader" className="loader-holder">
          <div className="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </footer>

      {/* <footer className={location.pathname === UserRoutes.MY_ACCOUNT ? "d-none" : ""}>
        <div className="container">
          <div className="row">
            <div className="col-md-6 text-md-start text-center">
              <Link to={UserRoutes.USER_ROOT}>
                <img src={Logo} className="img-fluid logo" />
              </Link>
            </div>
            <div className="col-md-6">
              <div className="social-links">
                <ul className="text-lg-end px-0 mb-0">
                  <li>
                    <a href="https://www.facebook.com/SubhashChandraFoundation" target="_blank" rel="noreferrer">
                      <i className="bi bi-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/Subhashchandra" target="_blank" rel="noreferrer">
                      <i className="bi bi-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/subhashchandrafoundation" target="_blank" rel="noreferrer">
                      <i className="bi bi-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/channel/UCXQbpATiZKmDnNc-XmN5PjA" target="_blank" rel="noreferrer">
                      <i className="bi bi-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <ul className="footer-nav p-0 mt-lg-3 footer-style">
                {menus.map((menu) => (
                  <li className="nav-item">
                    <Link className="nav-link" to={`/${menu?.cta?.path == "Counselling" ? "counseling" : menu?.cta?.path?.toLowerCase().replace(" ", "_")}`}>
                     {menu.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="border-dash mb-3"></div>
            </div>
            <div className="col-lg-6">
              <p className="copyright-info text-lg-start text-center">{bottomSection?.title}</p>
            </div>
            <div className="col-lg-6">
              <ul className="copyright-footer text-lg-end text-center px-0">
                {bottomSection?.subMenu?.map((menu, index) => (
                  <li key={index}>
                    <Link to={`/${parseHtml(menu?.cta?.path.toLowerCase().replace(" ", "_"))}`}>
                      {index !== 0 ? (
                        <span className="pe-2">
                          <i className="bi bi-circle-fill"></i>
                        </span>
                      ) : (
                        ""
                      )}
                      {parseHtml(menu.title)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </footer> */}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state,
    footerData: state?.CommonReducer?.footerData || {},
    dashboardData: state?.CommonReducer?.dashboardData || {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFooterData: () => dispatch(getFooterData()),
    getDashboardData: () => dispatch(getDashboardData()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
